import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { TestimonialsCompWrapper } from "../../styles/StyledComponents/TestimonialsCompWrapper";
import assests from "../../ui/assests";
import { testimonialMock } from "../../ui/json/demo.mock";
import CommonHeading from "../CommonHeading/CommonHeading";

const TestimonialsComp = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <TestimonialsCompWrapper className="cmn_gap_btm">
      <div className="container">
        <CommonHeading
          title="Testimonials"
          isPrimary
          style={{ marginBottom: "30px" }}
        />
        <div className="testimonialInner">
          <figure className="testimonialBg_overlay">
            <img src={assests.testimonialbg} alt="testimonialbg" />
          </figure>
          <div className="testimonial_data_Wrap">
            <Slider {...settings}>
              {testimonialMock?.map((data, index) => (
                <div className="slideCard_cols" key={index}>
                  <div className="row left_div cmn_col">
                    <i>
                      <img src={data?.profileimg} alt={data?.profileimg} />
                    </i>
                    <p>{data?.name}</p>
                  </div>
                  <div className="right_div cmn_col">
                    <div className="descriptionText">
                      <p>{data?.descriptionText}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </TestimonialsCompWrapper>
  );
};

export default TestimonialsComp;
